<div class="preview" [ngClass]="{'thumb': isThumb, 'preview-mode': isPreview && !isThumb}">
    @if (isPreview || !slideSubSceneData) {
        @if (!updating) {
            <app-scene-preview
                    [setSelectedSceneId]="sceneId"
                    [setSceneWidth]="width"
                    [setSceneHeight]="height"
                    [previewWidth]="isThumb ? slideThumbWidth : slideWidth"
                    [autoScale]="true"
                    [autoZoom]="isPreview && !isThumb"
                    (sceneLoaded)="onSceneLoaded($event)">
            </app-scene-preview>
            @if (!isThumb) {
                <div class="disabled-edit"></div>
            }
        } @else if (isThumb) {
            <div
                [ngStyle]="{
                    'height': slideThumbHeight + 'px',
                    'width': slideThumbWidth + 'px'
                }">
            </div>
        }
    } @else {
        <app-scene-builder
            [setSceneData]="slideSubSceneData"
            (playPreviewEvent)="onPlayPreviewEvent($event)"
            (touchAction)="onTouchAction($event)"
            [slideEditMode]="true">
        </app-scene-builder>
    }
</div>
